export default{sources:{avif:"__VITE_ASSET__C3v$7fPJ__ 400w",webp:"__VITE_ASSET__DwesxAnR__ 400w"},img:{src:"__VITE_ASSET__BJxTmtbp__",w:400,h:533}};